module.exports = __webpack_public_path__ + "img/logo-tag-manager.73b77ba0.webp";